import { useContext } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { LocalWidgetRouterContext, useWidgetNavigate } from '@/core/widgets/export';
import styles from '@/modules/calendar/components/forecast-game/forecast-frenzy.module.scss';

type ForecastFrenzyTab = 'overview' | 'pending' | 'badges';

const ROUTES: Record<ForecastFrenzyTab, string> = {
  overview: '',
  pending: 'pending',
  badges: 'badges',
};

function activeTab(path = ''): ForecastFrenzyTab {
  const [pathBase] = path.split('?');
  const segment = pathBase.replace(/^\/+|\/+$/g, '');
  const match = (Object.keys(ROUTES) as ForecastFrenzyTab[]).find(tab => ROUTES[tab] === segment);
  return match ?? 'overview';
}

export default function ForecastFrenzyTabBar() {
  const navigate = useWidgetNavigate();
  const active = activeTab(useContext(LocalWidgetRouterContext).path);

  return (
    <Tabs
      justify={true}
      activeKey={active}
      onSelect={key => key && navigate(ROUTES[key as ForecastFrenzyTab])}
      className={`mb-3 ${styles.tabBar}`}
    >
      <Tab eventKey={'overview'} title={'Overview'} />
      <Tab eventKey={'pending'} title={'Upcoming'} />
      <Tab eventKey={'badges'} title={'Badges'} />
    </Tabs>
  );
}
